import constants from '../constants';

const { fieldNames } = constants;

const TRIMMED_FIELD_NAMES = [
  fieldNames.TITLE,
  fieldNames.DESCRIPTION,
  fieldNames.KEYWORDS,
  fieldNames.OG_TITLE,
  fieldNames.OG_DESCRIPTION,
  fieldNames.OG_IMAGE,
  fieldNames.CANONICAL_URL,
];

const trimPageSettingsStrings = (settings) => {
  const nextSettings = { ...settings };

  TRIMMED_FIELD_NAMES.forEach((fieldName) => {
    if (typeof nextSettings[fieldName] === 'string') {
      nextSettings[fieldName] = nextSettings[fieldName].trim();
    }
  });

  return nextSettings;
};

export default trimPageSettingsStrings;
